import { get, has } from 'lodash';
import { apiSlice } from './apiSlice';
const transformErrorResponse = (response) => has(response?.data, 'message') ? get(response?.data, 'message') : "Something went wrong please try again";

export const alertApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // Create a new top-bar alert
        createAlert: builder.mutation({
            query: (data) => ({
                url: '/top-bar',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['ALERT'],
            transformResponse: (response) => response?.body,
            transformErrorResponse,
        }),

        // Update an existing top-bar alert
        updateAlert: builder.mutation({
            query: ({ id, payload }) => ({
                url: `/top-bar/${id}`,
                method: 'PUT',
                body: { ...payload },
            }),
            invalidatesTags: ['ALERT'],
            transformResponse: (response) => response?.body,
            transformErrorResponse,
        }),

        // Delete a top-bar alert
        deleteAlert: builder.mutation({
            query: (id) => ({
                url: `/top-bar/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['ALERT'],
            transformResponse: (response) => response?.body,
            transformErrorResponse,
        }),

        // Get top-bar alerts for admin
        getAlertsAdmin: builder.query({
            query: () => '/top-bar/admin',
            providesTags: ['ALERT'],
            transformResponse: (response) => response?.body,
            transformErrorResponse,
        }),

        // Get top-bar alerts for users
        getAlerts: builder.query({
            query: () => '/top-bar',
            providesTags: ['ALERT'],
            transformResponse: (response) => response?.body,
            transformErrorResponse,
        }),
    }),
});

export const {
    useCreateAlertMutation,
    useUpdateAlertMutation,
    useDeleteAlertMutation,
    useGetAlertsAdminQuery,
    useGetAlertsQuery,
} = alertApi;
